import { set } from '@/utils/vuex'

export default {
  SET_TOPICS: set('topics')
}
